<template>
  <div class="mainDetail">
    <div class="title">
      <span class="goback" @click="goback()">{{ detailInfo.classifyName }}</span> > <span>{{ detailInfo.title }}</span>
    </div>
    <article v-if="detailInfo" class="article-box">
      <div class="article-title">
        {{ detailInfo.title }}
      </div>
      <div id="viewBox" class="article-item" />
      <div v-show="detailInfo.attachmentUrl" class="attachmen">
        相关附件:
        <a :href="detailInfo.attachmentUrl">
          {{ detailInfo.attachmentUrl&&detailInfo.attachmentUrl.split("*").reverse()[0] }}
        </a>
      </div>
      <!-- <div class="video">
                <video height="432px"  controls="controls">
                    您的浏览器不支持 video 标签。
                </video>
            </div> -->
      <!-- <div class="article-item">

            </div> -->
    </article>
    <global-empty
      v-else
      :label="`暂无数据~`"
      height="200"
      link-it="3"
    />
  </div>
</template>
<script>
import { getPageDetail } from '@/api/helpCenter';
export default {
  data() {
    return {
      id: '',
      searchKey: null,
      classifyName: '',
      detailInfo: {}
    };
  },
  computed: {
    htmlCode() {
      var temp = document.createElement('div');
      temp.innerHTML = this.detailInfo.content;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.searchKey = this.$route.query.keyword;
    console.log(this.searchKey);
    this.classifyName = this.$route.query.classifyName;
  },
  mounted() {
    this.getPageDetail();
  },
  methods: {
    getPageDetail() {
      getPageDetail(this.id).then(res => {
        this.detailInfo = res.data;
        window.document.getElementById('viewBox').innerHTML = this.detailInfo.content;
        this.$EventBus.$emit('selectMenu', this.detailInfo.classifyId);
      }).catch(() => {});
    },
    goback() {
      console.log('goback ' + this.detailInfo.classifyId);
      this.$router.push({ name: 'mainItem', query: { keyword: this.searchKey }, params: { classifyId: this.detailInfo.classifyId }});
    }
  }
};
</script>
<style lang="scss" scoped>
.mainDetail{
    // width: calc(100% - 440px);
    margin-left: 210px;
    border: 1px solid #ECECEC;
    padding: 17px 20px;
    font-family: Microsoft YaHei;
    .goback {
      cursor: pointer;
      &:hover{
          color: #0089C9;
        }
    }
    .title{
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        border-bottom: 1px dashed #EAEAEA;
        padding-bottom: 20px;
        a:hover{
          color: #0089C9;
        }
    }
    .article-box{
        margin-top: 30px;
        color: #555555;
        .article-title{
            font-size: 16px;
            font-weight: bold;
        }
        .article-item{
            // font-size: 14px;
            line-height: 2;
            margin-top: 20px;
        }
        .video{
            margin: 40px auto;
        }
        .attachmen{
          text-align: right;
          margin-top: 20px;
          a{
             color: #0089C9;
          }
        }
    }
}
</style>
